"use client";

import { ExternalLink } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function DharmaVoices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  return <section ref={ref} className={`bg-primary-light py-16 px-6 md:px-12 lg:px-24 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-display text-foreground mb-3 text-center">
          Dharma Voices
        </h2>
        <p className="text-muted text-center mb-8 max-w-2xl mx-auto">
          Explore our collection of teachings and guided meditations
        </p>

        <div className="flex justify-center">
          <Link to="https://www.audiodharma.org/" newTab className="inline-flex items-center justify-center gap-2 rounded-md bg-primary text-foreground-primary px-6 py-3 font-semibold hover:bg-primary-hover hover:shadow-medium hover:-translate-y-0.5 active:bg-primary-active active:translate-y-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)]">
            Visit AudioDharma
            <ExternalLink className="size-4" />
          </Link>
        </div>
      </div>
    </section>;
}